import React, { memo } from "react";
import { ZLostTag, ZPopover, ZTypography, ZWonTag } from "@atoms";
import ZPipelineProgress from "../ZPipelineProgress";
import { IPipelineProgressPopoverProps } from "./interface";
import { EFontWeights } from "@atoms/ZTypography/interface";
import { customDateFormatter, isVendorApp } from "@/Utils";
import "./index.less";
import { useDatePattern } from "@/Hooks";

const ZPipelineProgressPopover: React.FC<IPipelineProgressPopoverProps> = ({
	sharerName,
	opportunityInsights,
	children
}) => {
	const datePattern = useDatePattern();
	if (!opportunityInsights) return <>{children}</>;
	const sharerType = isVendorApp() ? "Partner" : "Vendor";
	return (
		<ZPopover
			placement="bottomLeft"
			overlayClassName="z-pipeline-progress-popover"
			content={
				<div>
					<ZTypography.ZText
						weight={EFontWeights.MEDIUM}
						level={2}
						className="block mb-4"
					>
						Opportunity insights of {sharerType}
					</ZTypography.ZText>
					<div>
						<ZTypography.ZText level={1} colorVariant={8}>
							{sharerType}'s Name:{" "}
						</ZTypography.ZText>
						<ZTypography.ZText level={1} colorVariant={10}>
							{sharerName}
						</ZTypography.ZText>
					</div>
					<div>
						<ZTypography.ZText level={1} colorVariant={8}>
							{sharerType}'s opportunity stage:{" "}
						</ZTypography.ZText>
						<ZTypography.ZText level={1} colorVariant={10}>
							{opportunityInsights.stage}{" "}
							{opportunityInsights?.is_terminal_win_state && (
								<ZWonTag />
							)}
							{opportunityInsights?.is_terminal_lost_state && (
								<ZLostTag />
							)}
						</ZTypography.ZText>
					</div>
					<div>
						<ZTypography.ZText level={1} colorVariant={8}>
							Last Updated at:{" "}
						</ZTypography.ZText>
						<ZTypography.ZText level={1} colorVariant={10}>
							{opportunityInsights.updated
								? customDateFormatter(
										opportunityInsights.updated,
										datePattern
								  )
								: "--"}
						</ZTypography.ZText>
					</div>
					<ZPipelineProgress
						opportunityInsights={opportunityInsights}
					/>
				</div>
			}
		>
			{children}
		</ZPopover>
	);
};

export default memo(ZPipelineProgressPopover);
